import { Vue } from 'vue-property-decorator';
import store from '../../store';
import moment from 'moment-timezone';
import appointmentService from '../../services/appointment';
import tableMixin from '../../Mixins/table';
import appointmentMixin from '../../Mixins/appointment';
import stringUtil from '../../utils/stringUtil';
import numberUtil from '../../utils/number';
import dateTimeUtil from '../../utils/dateTime';

export default Vue.extend({
  store,
  mixins: [tableMixin, appointmentMixin],
  data: () => ({
    loadingAppointments: false,
    start: moment().format('Y-MM-DD'),
    search: '',
    appointments: [],
    appointmentHeaders: [
      {
        text: 'ID',
        align: 'center',
        value: 'id',
        sortable: true,
      },
      {
        text: 'Patient',
        align: 'center',
        value: 'patient_profile.firstname',
        sortable: false,
      },
      {
        text: 'Provider',
        align: 'center',
        value: 'provider_profile.firstname',
        sortable: false,
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: true,
      },
      {
        text: 'Type',
        align: 'center',
        value: 'type',
        sortable: true,
      },
      {
        text: 'Due',
        align: 'center',
        value: ' appointed_at',
        sortable: true,
      },
      {
        text: 'Reserved Time(Min.)',
        align: 'center',
        value: 'reserved_duration',
        sortable: true,
      },
      {
        text: 'Submit Draft',
        align: 'center',
        value: 'draft',
        sortable: true,
      },
      {
        text: 'Cancel Reason',
        align: 'center',
        value: 'cancel_reason',
        sortable: false,
      },
      {
        text: 'Net Price',
        align: 'center',
        value: 'price_detail.net_price',
        sortable: false,
      },
      {
        text: 'Start',
        align: 'center',
        value: 'start',
        sortable: false,
      },
      {
        text: 'End',
        align: 'center',
        value: 'end',
        sortable: false,
      },
      {
        text: "Patient's last wait",
        align: 'center',
        value: 'last_wait',
        sortable: false,
      },
      {
        text: "Provider's last wait",
        align: 'center',
        value: 'provider_profile.last_active',
        sortable: false,
      },
      {
        text: "Patient's last login",
        align: 'center',
        // value: 'provider_profile.last_active',
        sortable: false,
      },
      {
        text: "Provider's last login",
        align: 'center',
        // value: 'provider_profile.last_active',
        sortable: false,
      },
      {
        text: 'Use Coupon',
        align: 'center',
        value: 'coupon.code',
        sortable: false,
      },
      {
        text: 'Action',
        align: 'center',
        value: 'id',
        sortable: false,
      },
    ],
  }),
  computed: {
    stringUtil() {
      return stringUtil;
    },
    numberUtil() {
      return numberUtil;
    },
    dateTimeUtil() {
      return dateTimeUtil;
    },
  },
  watch: {},
  created() {},
  mounted() {
    appointmentService.all({ start: this.start }).then((data) => {
      this.appointments = data;
      console.log(data);
    });
  },
  methods: {},
});
